import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import pt from "./locales/pt.json";

export const SUPPORTED_LANGUAGES = ["en", "pt"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const DEFAULT_LANGUAGE: SupportedLanguage = "en";

const isSupported = (lng: string | undefined): lng is SupportedLanguage =>
	typeof lng === "string" && (SUPPORTED_LANGUAGES as readonly string[]).includes(lng);

void i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: en },
			pt: { translation: pt },
		},
		fallbackLng: DEFAULT_LANGUAGE,
		supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
		load: "currentOnly",
		interpolation: { escapeValue: false },
		detection: {
			order: ["localStorage", "navigator"],
			lookupLocalStorage: "graphless.lang",
			caches: ["localStorage"],
		},
	});

export function syncDocumentLanguage(language: string): void {
	if (typeof document === "undefined") return;
	const lang = isSupported(language) ? language : DEFAULT_LANGUAGE;
	document.documentElement.lang = lang;
}

void isSupported;
